import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Switch, TextField } from "@mui/material"
import React, { useEffect } from "react"
import moment from "moment"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';

export default function ComputerListBuildLicFormDialog(props) {
  const [userLevel, setUserLevel] = React.useState("BASIC")
  const [customConfig, setCustomConfig] = React.useState("")
  const [daysEndDate, setDaysEndDate] = React.useState("365")
  const [programSelector, setProgramSelector] = React.useState(props.sw_name)  
  const [power1day, setPower1day] = React.useState(false)
  const [endDateMode, setEndDateMode] = React.useState("predefined")
  const [halfYearOption, setHalfYearOption] = React.useState(moment().month() < 6 ? "30/6" : "31/12")
  const [customEndDate, setCustomEndDate] = React.useState(() => {
    const currentYear = moment().year();
    const june30 = moment(`${currentYear}-06-30`);
    const dec31 = moment(`${currentYear}-12-31`);
    return moment().isBefore(june30) ? june30 : dec31;
  });

  useEffect(() => {
    // Se esiste una programList, cerco l'entry corrispondente al programSelector
    // e imposto customConfig al valore `custom_config` se presente.
    if (props && Array.isArray(props.programList)) {
      const found = props.programList.find(p => p.selector === programSelector)
      if (found && found.custom_config !== undefined) {
        setCustomConfig(found.custom_config)
        return
      }
    }
    // se non trovo nulla, non modifico customConfig (comportamento precedente)
  }, [programSelector, props.programList])

  const handleClose = () => { props.onClickClose() }
  const handleSubmit = () => {
    if (!window.confirm("Are you sure?")) return 
    var d
    if (power1day) {
      // licenza POWER solo per 1 giorno
      d = moment().add(1, 'day')
    } else if (endDateMode === "custom") {
      d = moment(customEndDate)
    } else if (endDateMode === "predefined") {
      d = moment().add(daysEndDate, 'day')
    } else if (endDateMode === "halfyear") {
      const currentYear = moment().year()
      if (halfYearOption === "30/6") {
        d = moment(`${currentYear}-06-30`)
      } else {
        d = moment(`${currentYear}-12-31`)
      }
    }
    var d_str = d.format('DD/MM/YYYY') + " 22:59"
    // console.log(d_str)
    // return 
    var customConfig_value = customConfig
    if (!view_en.custom_config) {
      // se il custom config non e' visibile all'utente -> provo a leggere il valore da props.programList
      if (props && Array.isArray(props.programList)) {
        const found = props.programList.find(p => p.selector === programSelector)
        if (found && found.custom_config !== undefined) {
          customConfig_value = found.custom_config
        }
      }
      // altrimenti lascio il valore attuale (comportamento precedente)
    }
    props.onClickSubmit({
      userLevel: power1day ? "POWER" : userLevel,
      customConfig: customConfig_value,
      endDate: d_str,
      programSelector: programSelector,
    })
  }  
  const handleProgramSelectorChange = (e) => { setProgramSelector(e.target.value) }
  const handleCustomConfigChange = (e) => { setCustomConfig(e.target.value) }
  const handleUserLevelChange = (e) => { setUserLevel(e.target.value) }
  const handleEndDateChange = (e) => { setDaysEndDate(e.target.value) }
  const handleEndDateModeChange = (e) => { setEndDateMode(e.target.value) }
  const handleCustomEndDateChange = (date) => { setCustomEndDate(date) }
  const handleHalfYearOptionChange = (e) => { setHalfYearOption(e.target.value) }
  const program_text = () => {
    if (props.sw_name == '') { return ( <em>unknown</em> ) }
    return <>{props.sw_name} {props.sw_ver}</>
  }   
  const handle_chk_power_1day_change = (e) => {
    setPower1day(e.target.checked)
  }

  // **********************************************************
  // **********************************************************
  // **********************************************************

  var view_en = {
    program_selector: (props.sw_name == ''),
    custom_config: (props.is_admin || props.custom_config_en),
    user_level_standard: false,
    user_level_advanced: false,
    user_level_power: false,
    user_level_power_1day: false, // licenza POWER solo per 1 giorno
    cancel_button: true,
    build_button: true,
    show_spin: false,
  }  
  
  if (props.is_admin) {
    view_en.user_level_standard = true
    view_en.user_level_advanced = true
    view_en.user_level_power = true
    if (props.admin_comp || props.user_id === 1 /* canta */ || props.user_id === 13 /* verrocchio */) {
      // e' il computer di un admin, allora gli posso fare la licenza POWER
    } else {
      // anche se sono admin, per un NON ADMIN non posso fare la licenza POWER
      view_en.user_level_power = false
      view_en.user_level_power_1day = true
    }
    //console.log(props)
    view_en.build_button = true
  } else if (view_en.program_selector) {
    // non c'e' il nome del programma, in questo caso non faccio vedere gli altri livelli
    view_en.user_level_standard = true
    view_en.build_button = true
  } else {
    // qui dipende dal valore di "reseller_programs"
    // props.reseller_programs: "plus_max_landi, STANDARD\r\nomegas_landi"
    var rows = props.reseller_programs.split("\n")
    var max_level = "STANDARD"
    rows = rows.map(row => {
      if (row.includes(props.sw_name)) {
        // solo in questo caso abilito il pulsante
        view_en.build_button = true
        // vedo se devo attivare un livello piu' alto
        var parts = row.split(",")
        if (parts && parts.length > 1) {
          max_level = parts[1].trim().toUpperCase()
        }
      }
    })
    switch (max_level) {
      default:
        // testo non valido
        view_en.user_level_standard = false
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        // disabilito anche il pulsante
        view_en.build_button = false
        break;
      case "BASIC":
        view_en.user_level_standard = false
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        break;
      case "STANDARD": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = false
        view_en.user_level_power = false
        break;
      case "ADVANCED": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = true
        view_en.user_level_power = false
        break;
      case "POWER": 
        view_en.user_level_standard = true
        view_en.user_level_advanced = true
        view_en.user_level_power = true
        break;
    }
  }

  if (props.spin) {
    view_en.cancel_button = false
    view_en.build_button = false
    view_en.show_spin = true
  }
    
  // **********************************************************
  // **********************************************************
  // **********************************************************

  return (    
    <div>      
      <Dialog open={props.open} >
        <DialogTitle>BUILD LICENSE</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0, color: 'info.main' }}>
              User code: {props.user_code}
            </Box>
            <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0, color: 'info.main' }}>
              Program: {program_text()}
            </Box>
          </DialogContentText>          
          <br />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Stack spacing={3}>

              {view_en.program_selector && (
                <FormControl variant="standard" >
                  <InputLabel id="demo-simple-select-standard-label">PROGRAM SELECTOR</InputLabel>
                  <Select
                    id="program_selector"
                    value={programSelector}
                    onChange={handleProgramSelectorChange}
                    label="PROGRAM SELECTOR"
                    disabled={view_en.show_spin} >
                    {props.programList.sort((a, b) => (a.name > b.name) ? 1 : -1).map(item => {
                      return <MenuItem key={item.selector} value={item.selector}>{item.name}</MenuItem>
                    })}
                  </Select>
                </FormControl> )}

              {!power1day && <FormControl variant="standard" >
                <InputLabel id="demo-simple-select-standard-label">USER LEVEL</InputLabel>
                <Select
                  id="user_level"
                  value={userLevel}
                  onChange={handleUserLevelChange}
                  label="USER LEVEL"
                  disabled={view_en.show_spin} >
                  <MenuItem value="BASIC">BASIC</MenuItem>
                  {view_en.user_level_standard && (<MenuItem value="STANDARD">STANDARD</MenuItem>)}
                  {view_en.user_level_advanced && (<MenuItem value="ADVANCED">ADVANCED</MenuItem>)}
                  {view_en.user_level_power && (<MenuItem value="POWER">POWER</MenuItem>)}
                </Select>
              </FormControl>}

              {view_en.user_level_power_1day && <FormGroup>
                <FormControlLabel 
                  disabled={false}
                  control={<Switch 
                    checked={power1day}
                    onChange={handle_chk_power_1day_change}
                    inputProps={{ 'aria-label': 'controlled' }} />}
                  label="POWER USER LEVEL FOR 1 DAY ONLY" />
              </FormGroup>}
              
              {view_en.custom_config && (
                <TextField
                  value={customConfig}
                  margin="dense"
                  id="custom_config"
                  label="CUSTOM CONFIG"
                  onChange={handleCustomConfigChange}
                  type="text"
                  fullWidth
                  variant="standard"
                  disabled={view_en.show_spin} /> )}

              {!power1day && <FormControl margin="dense" variant="standard">
                <InputLabel id="demo-simple-select-standard-label">END DATE MODE</InputLabel>
                <Select
                  id="end_date_mode"
                  onChange={handleEndDateModeChange}
                  value={endDateMode}
                  label="END DATE MODE"
                  disabled={view_en.show_spin} >
                  <MenuItem value="predefined">Predefined Durations</MenuItem>
                  <MenuItem value="custom">Custom Date</MenuItem>
                  <MenuItem value="halfyear">Half Year</MenuItem>
                </Select>
              </FormControl>}

              {endDateMode === "predefined" && !power1day && <FormControl margin="dense" variant="standard">
                <InputLabel id="demo-simple-select-standard-label">END DATE</InputLabel>
                <Select
                  id="mode"
                  onChange={handleEndDateChange}
                  value={daysEndDate}
                  label="END DATE"
                  disabled={view_en.show_spin} >
                  <MenuItem value="1">1 day</MenuItem>
                  <MenuItem value="2">2 days</MenuItem>
                  <MenuItem value="7">1 week</MenuItem>
                  <MenuItem value="30">1 month</MenuItem>
                  <MenuItem value="91">3 months</MenuItem>
                  <MenuItem value="182">6 months</MenuItem>
                  <MenuItem value="365">1 year</MenuItem>
                </Select>
              </FormControl>}

              {endDateMode === "custom" && !power1day && (
                <DatePicker
                  label="Custom End Date"
                  value={customEndDate}
                  onChange={handleCustomEndDateChange}
                  renderInput={(params) => <TextField {...params} />}
                  inputFormat="DD/MM/YYYY"
                  disabled={view_en.show_spin}
                />
              )}

              {endDateMode === "halfyear" && !power1day && (
                <FormControl margin="dense" variant="standard">
                  <InputLabel id="demo-simple-select-standard-label">HALF YEAR END DATE</InputLabel>
                  <Select
                    id="half_year_option"
                    onChange={handleHalfYearOptionChange}
                    value={halfYearOption}
                    label="HALF YEAR END DATE"
                    disabled={view_en.show_spin} >
                    <MenuItem value="30/6">30/6/{moment().year()}</MenuItem>
                    <MenuItem value="31/12">31/12/{moment().year()}</MenuItem>
                  </Select>
                </FormControl>
              )}

            </Stack>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.build_button} onClick={handleSubmit}>Build and Send</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}